export default __webpack_public_path__ + "static/media/BC home.6648105b.PNG";